export const FIRST_PAGE = 1

export const LIMIT = 10

export const SUCCESS_CODE = '200'